'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryButton = require('./components/PrimaryButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/primary/index.js
// module id = 1046
// module chunks = 1